import { HttpClient } from '@angular/common/http';
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DialogGeneral } from '../DialogGeneral';

export interface DialogPdfData {
  header: string;
  pdfSrc: string; // Base64 eða URL
  fileName: string;
}

@Component({
  selector: 'dialog-pdf',
  templateUrl: 'dialog-pdf.html',
  styleUrls: ['dialog-pdf.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DialogPdf extends DialogGeneral {

  pdfUrl: SafeResourceUrl | null = null;

  constructor(
    public matDialogRef: MatDialogRef<DialogPdf>,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    public override dialogRef: MatDialogRef<DialogPdf>,
    @Inject(MAT_DIALOG_DATA) public data: DialogPdfData
  ) {
    super(matDialogRef);
    this.loadPdf();
  }

  private loadPdf() {
        const blobUrl = this.base64ToPdfUrl(this.data.pdfSrc);

        // Ef við erum með android þá þarf notandinn einfaldlega að hlaða niður skjalinu sjálfur.
        // Annars reynum við að birta skjalið beint.
        if (!this.isAndroid()) {
            this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
        }
  }

  private isAndroid(): boolean {
    return /Android/i.test(navigator.userAgent);
  }

  private base64ToPdfUrl(base64: string): string {
    // Fjarlægja data URI prefix ef hann er til staðar
    const base64Data = base64.includes(',') ? base64.split(',')[1] : base64;

    try {
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });

      return URL.createObjectURL(blob);
    } catch (error) {
      console.error('Villa við base64 afkóðun:', error);
      return '';
    }
  }

  downloadPdf() {
        const { pdfSrc, fileName } = this.data;

        // Athugar hvort pdfSrc byrji á "data:application/pdf;base64,"
        const isBase64 = typeof pdfSrc === 'string' && pdfSrc.toLowerCase().startsWith('data:application/pdf;base64,');

        if (isBase64) {
            const base64Data = pdfSrc.split(',')[1]; // fjarlægir "data:..." hausinn
            const byteCharacters = atob(base64Data);
            const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });

            if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
                (window.navigator as any).msSaveOrOpenBlob(blob, fileName);
            } else {
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } else {
            // Annar textastrengur er álitinn sem URL
            this.http.get(pdfSrc, { responseType: 'blob' }).subscribe(blob => {
                if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
                    (window.navigator as any).msSaveOrOpenBlob(blob, fileName);
                } else {
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = fileName;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            });
        }
    }

}
